import { useTranslation } from 'react-i18next';

// Seed canonical values are stored in Korean on the wire (PRD 03 §3.3 — single
// canonical option pool), but the UI must localize them. User-added options
// (via the invite panel's "+ Add") have no canonical key and fall back to the
// raw value.
const DEPARTMENT_KEYS: Record<string, string> = {
  정신건강의학과: 'psychiatry',
  신경과: 'neurology',
  재활의학과: 'rehabMedicine',
  내분비내과: 'endocrinology',
  심장내과: 'cardiology',
  가정의학과: 'familyMedicine',
  간호부: 'nursing',
  임상시험센터: 'clinicalTrialsCenter',
};

const JOB_ROLE_KEYS: Record<string, string> = {
  의사: 'doctor',
  간호사: 'nurse',
  CRC: 'crc',
};

export function useTranslateOption() {
  const { t } = useTranslation('admin');

  const translateDepartment = (canonical: string): string => {
    const key = DEPARTMENT_KEYS[canonical];
    if (!key) return canonical;
    return t(`medicalStaffManagement.options.departments.${key}`, {
      defaultValue: canonical,
    });
  };

  const translateJobRole = (canonical: string): string => {
    const key = JOB_ROLE_KEYS[canonical];
    if (!key) return canonical;
    return t(`medicalStaffManagement.options.jobRoles.${key}`, {
      defaultValue: canonical,
    });
  };

  return { translateDepartment, translateJobRole };
}
